import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useLang } from "../i18n/LangContext";
import { KenBurns } from "./KenBurns";

export const CinematicBreak = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "15%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.1, 1.25]);

  return (
    <section
      ref={ref}
      className="relative h-[65vh] md:h-[85vh] w-full overflow-hidden bg-[#0A0A0B]"
      data-testid="cinematic-section"
    >
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <KenBurns
          duration={7000}
          images={[
            "https://images.unsplash.com/photo-1777328511966-c1dcb1d21b9a?auto=format&fit=crop&w=2400&q=90",
            "https://images.unsplash.com/photo-1770804090630-183510de10e7?auto=format&fit=crop&w=2400&q=90",
            "https://images.unsplash.com/photo-1763026481968-9c6240527c37?auto=format&fit=crop&w=2400&q=90",
            "https://images.unsplash.com/photo-1772990914935-a2c506de480c?auto=format&fit=crop&w=2400&q=90",
            "https://images.unsplash.com/photo-1762359912964-0a5786da3868?auto=format&fit=crop&w=2400&q=90",
          ]}
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B]/55 via-[#0A0A0B]/35 to-[#0A0A0B]/88" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at center, transparent 30%, rgba(10,10,11,0.85) 100%)",
        }}
      />

      <div className="relative z-10 h-full max-w-[1600px] mx-auto px-6 md:px-10 flex flex-col justify-end pb-14 md:pb-20 text-[#F1EEE8]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.7, 0, 0.2, 1] }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3 text-[#8A6F45] text-[0.7rem] tracking-[0.28em] uppercase mb-6">
            <span className="w-6 h-px bg-[#8A6F45]" />
            <span>{t.cinematic.overline}</span>
          </div>
          <h2 className="font-display font-medium leading-[1.02] tracking-tight text-[clamp(2rem,5vw,4.5rem)] whitespace-pre-line mb-6">
            {t.cinematic.title}
          </h2>
          <p className="text-[#F1EEE8]/75 max-w-xl leading-relaxed text-[1.02rem]">
            {t.cinematic.body}
          </p>
        </motion.div>
      </div>
    </section>
  );
};
